import React, { useEffect, useState } from 'react';
import DOMPurify from 'dompurify';
import { useNavigate } from 'react-router-dom';
import getBaseUrl from './../../utils/baseUrl';
import './../../styles/AndroidInstallPageMobile.css';
import useAndroidBody  from './../hooks/useAndroidBody.js';

const fetchGuideHtml = async (fileName) => {
  const res = await fetch(`${getBaseUrl()}/guides/android/${fileName}`);
  if (!res.ok) throw new Error(`Failed to fetch ${fileName}`);
  const text = await res.text();
  return DOMPurify.sanitize(text);
};

export default function AndroidIntro() {
  useAndroidBody();
  const nav = useNavigate();
  const [html, setHtml] = useState('');
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState('');

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const content = await fetchGuideHtml('android1.html');
        setHtml(content);
      } catch {
        setErr('Could not load content.');
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <div className="android-install ai-wrap">
      <header className="ai-header"><div className="ai-header__title"><span>eSafe for Android</span></div></header>
      <main className="ai-main">
        <section className="card">
          <h2>Before you start</h2>
          {loading ? <div className="skeleton"><div className="skeleton__line"/></div>
                   : err ? <div className="muted">{err}</div>
                          : <div className="html-content" dangerouslySetInnerHTML={{ __html: html }} />}
          <button className="btn btn--primary" onClick={() => nav('/android/visor-id')}>Continue</button>
        </section>
      </main>
    </div>
  );
}
